import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
} from "@ngrx/store";

import * as fromLegalEntity from "./legalEntity.reducer";
import * as fromCompany from "./company.reducer";
import * as fromExternalApp from "./ExternalAppData.reducer";

import { Company } from "../models/company.model";

import * as fromCountryParameters from "./countryParameters.reducer";

export interface State {
  legalEntity: fromLegalEntity.State;
  companies: fromCompany.State;
  countryParameters: fromCountryParameters.State;
  externalAppData: fromExternalApp.State;
}

export const reducers: ActionReducerMap<State> = {
  legalEntity: fromLegalEntity.reducer,
  companies: fromCompany.reducer,
  countryParameters: fromCountryParameters.reducer,
  externalAppData: fromExternalApp.reducer,
};

const getCoreState = createFeatureSelector<State>("core");
const getLegalEntityState = createSelector(
  getCoreState,
  (state) => state && state.legalEntity
);
const getCompaniesState = createSelector(
  getCoreState,
  (state) => state && state.companies
);
const getCountryParametersState = createSelector(
  getCoreState,
  (state) => state && state.countryParameters
);
const getExternalAppDataState = createSelector(
  getCoreState,
  (state) => state && state.externalAppData
);

export const getLegalEntity = createSelector(
  getLegalEntityState,
  (state) => state && state.legalEntity
);

const getCompaniesEntities = createSelector(
  getCompaniesState,
  fromCompany.getCompaniesEntities
);
const getSelectedCompanyCode = createSelector(
  getCompaniesState,
  fromCompany.getSelectedCompanyCode
);

export const getCompaniesArray = createSelector(
  getCompaniesState,
  fromCompany.getCompaniesArray
);

export const getPayableCompanies = createSelector(
  getCompaniesState,
  (state) => {
    let companies = [] as Company[];
    if (state && state.entities) {
      companies = Object.keys(state.entities).map((i) => state.entities[i]);
      companies = companies.filter(
        (x) => x.paymentAllowed && x.paymentAllowed === 1
      );
    }
    return companies;
  }
);

export const getSelectedCompany = createSelector(
  getCompaniesEntities,
  getSelectedCompanyCode,
  (entities, selectedCompanyCode) =>
    selectedCompanyCode && entities[selectedCompanyCode]
);

export const getCompany = createSelector(
  getCompaniesEntities,
  getSelectedCompanyCode,
  (entities, selectedCompanyCode) =>
    selectedCompanyCode && entities[selectedCompanyCode]
);

const getCountryParametersEntities = createSelector(
  getCountryParametersState,
  fromCountryParameters.getParametersEntities
);
const getSelectedCountryParameterId = createSelector(
  getCountryParametersState,
  fromCountryParameters.getSelectedParameterId
);

export const getCountryParameters = createSelector(
  getCountryParametersState,
  fromCountryParameters.getCountryParameters
);

export const getSelectedCountryParameter = createSelector(
  getCountryParametersEntities,
  getSelectedCountryParameterId,
  (entities, selectedCountryParameterId) =>
    selectedCountryParameterId && entities[selectedCountryParameterId]
);

export const getExternalAppData = createSelector(
  getExternalAppDataState,
  (state) => state && state.config
);
